<i18n src="@/locales/modules/RequestTranslate.json"></i18n>

<template>
	<vs-table ref="table" class="request-table stack-table" :sst="true" :data="parsedData" :noDataText="$t('Notify.NoDataAvailable')" @sort="handleSortChange">
		<template slot="thead">
			<vs-th></vs-th>
			<vs-th v-if="checkColumnDisplay('code')" :sort-key="isQuickMode ? null : 'code'" :class="{ 'no-sorter': isQuickMode }">{{ $t("Code") }}</vs-th>
			<vs-th v-if="checkColumnDisplay('requester')" :sort-key="isQuickMode ? null : 'requested_by'" :class="{ 'no-sorter': isQuickMode }">{{ $t("Creator") }}</vs-th>
			<vs-th v-if="checkColumnDisplay('reqtype')" :sort-key="isQuickMode ? null : 'req_type_id'" :class="{ 'no-sorter': isQuickMode }">{{ $t("RequestType") }}</vs-th>
			<vs-th v-if="checkColumnDisplay('request_reason')" :sort-key="isQuickMode ? null : 'request_reason'" :class="{ 'no-sorter': isQuickMode }">{{ $t("Purpose") }}</vs-th>
			<vs-th v-if="checkColumnDisplay('created_at')" :sort-key="isQuickMode ? null : 'created_at'" :class="{ 'no-sorter': isQuickMode }">{{ $t("CreatedDate") }}</vs-th>
			<vs-th v-if="checkColumnDisplay('number')" sort-key="number">{{ $t("Number") }}</vs-th>
			<vs-th v-if="checkColumnDisplay('reqstatus') && !isQuickMode" sort-key="status">{{ $t("Status") }}</vs-th>
			<vs-th class="no-sorter"></vs-th>
		</template>

		<template slot-scope="{ data }">
			<tbody>
				<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click.native="handleClickRequestItemRow($event, tr)">
					<vs-td class="lg:w-4">
						<div class="flex items-center">
							<cbs-color-picker
								mode="flag"
								:colors="noteColors"
								:listHeaderText="''"
								:value="tr.userOptionColor"
								:ref="`colorPickerRef-${tr.id}`"
								@input="color => handleSetMarkedColor(tr.id, color)"
							/>
						</div>
					</vs-td>
					<vs-td :data-header="$t('Code')" v-if="checkColumnDisplay('code')">
						<p class="font-medium">{{ tr.code || '' }}</p>
					</vs-td>
					<vs-td :data-header="$t('Creator')" v-if="checkColumnDisplay('requester')">
						<p class="font-medium">{{ tr.requestProposerName }}</p>
					</vs-td>

					<vs-td :data-header="$t('RequestType')" v-if="checkColumnDisplay('reqtype')">
						<p class="font-medium">{{ tr.requestTypeName }}</p>
					</vs-td>

					<vs-td :data-header="$t('Purpose')" v-if="checkColumnDisplay('request_reason')">
						<p class="font-medium max-w-xs">{{ tr.request_reason || "" }}</p>
					</vs-td>

					<vs-td :data-header="$t('CreatedDate')" class="lg:w-40" v-if="checkColumnDisplay('created_at')">
						<p class="font-medium">{{ tr.createdDate | dateTime(userDateFormat) }}</p>
					</vs-td>

					<vs-td :data-header="$t('Number')" class="lg:w-40" v-if="checkColumnDisplay('number')">
						<p :set="nums=generateNumber(tr)">
							<label class="custom-num-req" v-for="(num, idxNum) in nums" :key="idxNum" :title="num.title">{{ num.value || '' }}</label>
						</p>
					</vs-td>

					<vs-td v-if="checkColumnDisplay('reqstatus') && !isQuickMode" :data-header="$t('Status')" class="lg:w-64" >
						
						<request-steps class="-mx-6" :value="handleSetActiveRequestDataByRequestItem2(tr)" :isShort="true" :updatedAt="tr.updated_at"/>

						<!-- <p
							:class="[
								{
									'text-solid-red': tr.is_reject,
									'text-solid-green-1': tr.is_done,
									'text-solid-gray-1': tr.is_cancel,
									'text-solid-orange-1': tr.reqstatus && tr.reqstatus.pending_input && !tr.is_cancel,
									'text-solid-primary': !tr.is_done && !tr.is_reject && !tr.is_cancel && tr.reqstatus && !tr.reqstatus.pending_input
								},
								'font-bold'
							]"
						>
							<span v-if="tr.is_done">
								{{ $t("Complete") }}
							</span>
							<span v-else-if="tr.is_cancel">{{ $t("Canceled") }}</span>
							<span v-else>
								{{ tr.requestStatusName }}
								<span v-if="tr.is_reject"> - {{ $t("Rejected") }} </span>
								<span v-else-if="!tr.is_done && !tr.is_reject && !tr.is_cancel && tr.reqstatus && !tr.reqstatus.pending_input"> - {{ $t("Waiting") }} </span>
							</span>
						</p> -->
					</vs-td>

					<vs-td class="whitespace-no-wrap text-right">
						<request-context-menu
							type="vertical"
							:request="tr"
							@onClickEdit="handleClickEditMenu"
							@onClickCancel="handleClickCancelMenu"
							@onClickRecreate="handleClickRecreateMenu"
							@onClickReject="showApproveOrRejectConfirm"
							@onClickDuplicate="handleClickDuplicateMenu"
							@onClickDownload="handleClickDownload"
							@onClickCreateTodo="handleClickCreateTodoMenu"
							@onClickAgree="requestId => showApproveOrRejectConfirm(requestId, true)"
						/>
					</vs-td>
				</vs-tr>
			</tbody>
		</template>
	</vs-table>
</template>

<script>
import RequestSteps from "./RequestSteps";
import RequestContextMenu from "./RequestContextMenu";
import CbsColorPicker from "@/components/cbs-color-picker/CbsColorPicker";

export default {
	name: "RequestTable",
	components: {
		RequestSteps,
		CbsColorPicker,
		RequestContextMenu
	},
	props: {
		data: {
			type: Array,
			required: true
		},
		isQuickMode: Boolean,
		displayColumns: Object
	},
	emits: {
		onSortChange: {},
		onClickRowItem: {},
		onClickEditMenu: {},
		onSetMarkedColor: {},
		onClickCancelMenu: {},
		onClickCreateTodo: {},
		onClickRecreateMenu: {},
		onClickApproveOrRejectConfirm: {}
	},
	computed: {
		noteColors() {
			return this.$constant.PICKER_MARK_COLORS || [];
		},
		parsedData() {
			return this.data.map(request => this.formatRequest(request));
		}
	},
	methods: {
		generateNumber(item) {
			let nums = [];
			let numMaps = {};
			if (item && item.reqtype && Array.isArray(item.reqtype.controls)) {
				item.reqtype.controls.forEach(control => {
					if (control.control == this.$constant.request.control.number || control.control == this.$constant.request.control.calculator) {
						let itemData = JSON.parse(item.data);
						if (itemData && itemData.parent && itemData.parent.hasOwnProperty(control.id)) {
							let val = itemData.parent[control.id];
							if (!isNaN(val) && val) {
								val = parseFloat(val);
								if (!numMaps.hasOwnProperty(val)) {
									numMaps[val] = 1;
									val = this.$helper.numFormat(val);
									nums.push({
										value: val,
										title: control.title
									});
								}
							}
						}
					}
				})
			}
			return nums;
		},
		checkColumnDisplay(column) {
			if (this.displayColumns && this.displayColumns.hasOwnProperty(column)) {
				return this.displayColumns[column] == '1';
			}
			return true;
		},
		getParsedRequestTypeSteps(requestTypeSteps = []) {
			const activeStepIndex = requestTypeSteps.findIndex(step => step.is_active);
			return requestTypeSteps.map((step, index) => ({
				id: step.id,
				name: step.name,
				// set status null to all steps behind active step
				status: activeStepIndex > -1 && index <= activeStepIndex ? step.status : null,
				color: step.color || null
			}));
		},
		handleSetActiveRequestDataByRequestItem2(requestItem) {
			const activeRequestType = requestItem.reqtype || {};
			let requestTypeSteps = this.getParsedRequestTypeSteps(activeRequestType.statuses || []);
			const isRequestDone = requestItem.is_done;
			const isRequestCanceled = requestItem.is_cancel;
			if (isRequestCanceled) {
				requestTypeSteps = requestTypeSteps.map(step => {
					return {
						...step,
						status: null,
					};
				});
			}

			return [
				{
					id: `create-step-${activeRequestType.id}`,
					name: this.$t("CreateRequest"),
					status: isRequestCanceled ? this.$constant.REQUEST_STATUSES.CANCELED : this.$constant.REQUEST_STATUSES.APPROVED,
				},
				...requestTypeSteps,
				{
					id: `completed-step-${activeRequestType.id}`,
					name: this.$t(`RequestStepComplete`),
					status: isRequestDone ? this.$constant.REQUEST_STATUSES.APPROVED : null
				}
			];
		},
		formatRequest(request) {
			const activeStepName = request && request.reqstatus && request.reqstatus.name;
			let requestStatus;
			if (!request.is_done && !request.is_reject) {
				requestStatus = this.$constant.REQUEST_STATUSES.WAITING;
			}
			if (request.is_done) {
				requestStatus = this.$constant.REQUEST_STATUSES.APPROVED;
			}
			if (request.is_reject) {
				requestStatus = this.$constant.REQUEST_STATUSES.REJECTED;
			}
			if (request.is_cancel) {
				requestStatus = this.$constant.REQUEST_STATUSES.CANCELED;
			}

			return {
				...request,
				status: requestStatus,
				requestStatusName: activeStepName,
				createdDate: request.created_at || "",
				requestTypeName: (request && request.reqtype && request.reqtype.name) || "",
				requestProposerName: (request && request.requester && request.requester.name) || "",
				userOptionColor: (request.user_option && request.user_option.color) || this.$constant.PICKER_MARK_COLORS[0].value
			};
		},
		handleSortChange(columnName, order) {
			if (columnName) {
				this.$emit("onSortChange", columnName, order);
			}
		},
		handleClickRequestItemRow(event, requestItem) {
			const eventClasses = event.target && event.target.className;
			// show detail dialog if click target is not below classes
			if (event.target !== event.currentTarget && !eventClasses.split(" ").find(className => ["cbs-context-menu", "cbs-color-picker"].includes(className))) {
				this.$emit("onClickRowItem", requestItem);
			}
		},
		handleSetMarkedColor(requestId, value) {
			const colorPickerRef = this.$refs[`colorPickerRef-${requestId}`];
			this.$emit("onSetMarkedColor", requestId, value, colorPickerRef);
		},
		handleClickEditMenu(data) {
			this.$emit("onClickEditMenu", data);
		},
		handleClickRecreateMenu(data) {
			this.$emit("onClickRecreateMenu", data);
		},
		handleClickDuplicateMenu(data) {
			this.$emit("onClickDuplicate", data);
		},
		handleClickDownload(data) {
			this.$emit("onClickDownload", data);
		},
		handleClickCancelMenu(data) {
			this.$emit("onClickCancelMenu", data);
		},
		handleClickCreateTodoMenu(data) {
			this.$emit("onClickCreateTodo", data);
		},
		showApproveOrRejectConfirm(dataId, isApprove) {
			this.$emit("onClickApproveOrRejectConfirm", dataId, isApprove);
		}
	}
};
</script>

<style lang="scss" scoped>
.custom-num-req {
	text-decoration: underline;
	cursor: help;
	padding-right: 5px;
}
</style>